import { Typography } from 'antd';
import { useRouter } from 'next/router';
import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import GrispiTooltipLink from '../../../components/GrispiTooltipLink';
import { getTenantId } from '../../../utils/accountHelper';
const { Paragraph } = Typography;

const ExternalReportsContainer = () => {
    const { t } = useTranslation('reports');
    const { push } = useRouter();
    const tenantId = getTenantId();
    useEffect(() => {
        if (tenantId !== 'yolcu360') push('/');
    }, [push, tenantId]);

    if (tenantId !== 'yolcu360') return null;

    return (
        <>
            <Paragraph style={{ margin: 0 }}>
                {t('externalReports.lastPageRecords')}
                <GrispiTooltipLink
                    href="https://lookerstudio.google.com/reporting/7bd3f537-2c69-424e-b0aa-01439ea374ba/page/iThUD"
                    tooltipText={t('clickForMoreDetails.clickForMoreDetails')}
                >
                    {t('externalReports.clickForRedirection')}
                </GrispiTooltipLink>
                {'.'}
            </Paragraph>
            <Paragraph style={{ margin: 0 }}>
                {t('externalReports.failedPayment')}
                <GrispiTooltipLink
                    href="https://lookerstudio.google.com/reporting/7bd3f537-2c69-424e-b0aa-01439ea374ba/page/iThUD"
                    tooltipText={t('clickForMoreDetails.clickForMoreDetails')}
                >
                    {t('externalReports.clickForRedirection')}
                </GrispiTooltipLink>
                {'.'}
            </Paragraph>
        </>
    );
};

export default ExternalReportsContainer;
